import { FichaService } from './../../ficha-veiculo.service';
import { Component, Input, OnInit } from '@angular/core';
import { FichaCadastro } from './../ficha-cadastro';
import { setFichaContent } from '../helpers/salvarFicha';
import { Avalista } from '../model/avalista';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-ficha-cadastro-endereco-avalista',
  templateUrl: './ficha-cadastro-endereco-avalista.component.html',
  styleUrls: ['./ficha-cadastro-endereco-avalista.component.css'],
})
export class FichaCadastroEnderecoAvalistaComponent implements OnInit {
  constructor(private fichaService: FichaService) {}

  @Input() fichaCadastro: FichaCadastro;
  @Input() index: number;

  ngOnInit() {
    if (this.fichaCadastro.setDadosAvalistas && this.fichaCadastro.setDadosAvalistas[this.index]) {
      this.fichaCadastro.avalistas[this.index] = new Avalista();
    }
  }

  onClickPrevious() {
    this.fichaCadastro.onClickPrevious();
  }

  nextAvaliable(...data) {
    if (
      this.fichaCadastro.avalistas[this.index].tipoEnderecoCorrespondencia ===
      '7'
    ) {
      return data.every((item) => {
        return item === true;
      });
    }
    return data[0];
  }

  onClickNext() {
    this.fichaCadastro.avalistas[this.index].enderecos.idTipoEndereco = 1;
    this.fichaCadastro.avalistas[this.index].enderecoCorrespondencia.idTipoEndereco =
      this.fichaCadastro.avalistas[this.index].tipoEnderecoCorrespondencia ===
      '7'
        ? 7
        : undefined;
    this.fichaCadastro.onClickNext();
    setFichaContent(this.fichaCadastro);
    this.putDataClient();
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  get numeroAvalista() {
    return Number(this.index) + 1;
  }

  getCep(correspondence = false) {
    const endereco = this.fichaCadastro.recoverData.proposal.guarantors[this.index]
      ? this.fichaCadastro.recoverData.proposal.guarantors[this.index].addresses.find(
          (a) =>
            a.addressTypeId ===
              (!correspondence
                ? this.fichaCadastro.avalistas[this.index].enderecos
                : this.fichaCadastro.avalistas[this.index]
                    .enderecoCorrespondencia
              ).idTipoEndereco && a.correspondence === correspondence
        )
      : undefined;

    return endereco ? endereco.singleZipCode : '';
  }

  getCepComercial() {
    if (
      this.fichaCadastro.recoverData.proposal.guarantors[this.index] &&
      this.fichaCadastro.recoverData.proposal.guarantors[this.index]
        .professionalData &&
      this.fichaCadastro.recoverData.proposal.guarantors[this.index]
        .professionalData.address &&
      this.fichaCadastro.recoverData.proposal.guarantors[this.index]
        .professionalData.address.singleZipCode
    ) {
      return this.fichaCadastro.recoverData.proposal.guarantors[this.index]
        .professionalData.address.singleZipCode;
    }
    return undefined;
  }
}
